import React, { useCallback, useEffect, useState } from 'react';
import { SearchNormalIcon } from 'icons';
import debounce from 'lodash.debounce';
import { useTranslations } from 'next-intl';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

function SearchInput() {
  const t = useTranslations();
  const [queryParams, setQueryParams] = useQueryParams({
    search: withDefault(StringParam, ''),
    page: withDefault(StringParam, '1')
  });
  const [tempValue, setTempValue] = useState<string>(queryParams?.search);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearch = useCallback(
    debounce((val: string) => {
      setQueryParams({
        search: val || undefined,
        page: undefined
      });
    }, 500),
    []
  );

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    setTempValue(val);
    debouncedSetSearch(val);
  };

  useEffect(() => {
    setTempValue(queryParams?.search);
  }, [queryParams?.search]);

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <SearchNormalIcon />
      </div>
      <input
        type="text"
        value={tempValue}
        onChange={onChange}
        placeholder={`${t('Qidiruv')}...`}
        className="sm:w-80 w-full block rounded-full bg-white py-2 sm:py-1.5 pl-10 pr-3 leading-5 placeholder-gray-500 focus:border-green-500 text-sm focus:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-green-500"
      />
    </div>
  );
}

export default SearchInput;
